import {Component, ElementRef, Input, OnInit, ViewChild} from '@angular/core';
import {BotMessage} from '../models/message.model';
import {Suggestion} from '../models/chat-component.model';
import {formatChatText, getValidSuggestions} from '../utils/chat.util';
import {CHAT_CONSTANTS} from '../utils/app.constants';


@Component({
  selector: 'app-chat-message',
  templateUrl: './chat-message.component.html',
  styleUrls: ['./chat-message.component.scss']
})
export class ChatMessageComponent implements OnInit {
  @Input() message: any;
  @Input() handleSuggestionClick!: (suggestion: Suggestion) => void;
  readonly MESSAGE_TYPES = CHAT_CONSTANTS.MESSAGE_TYPES;
  readonly TABLE_TYPES = CHAT_CONSTANTS.TABLE_TYPES;
  readonly COMPONENT_TYPES = CHAT_CONSTANTS.COMPONENT_TYPES;


  constructor() {
  }

  ngOnInit(): void {
  }

  toggleNotifications(botMsg: BotMessage) {
    botMsg.showNotifications = !botMsg.showNotifications;
  }

  protected readonly formatChatText = formatChatText;
  protected readonly getValidSuggestions = getValidSuggestions;
}
